import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProductSizeService {
  private headerOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(private http: HttpClient) { }

  // add  currency
  addNewproductSize(data) {
    return this.http.post('api/product/admin/categorySize/add', JSON.stringify(data), this.headerOptions)
  }

  // update currency
  updateCurrency(data, id) {
    return this.http.post('api/currency/updateCurrency?id=' + id, JSON.stringify(data), this.headerOptions)
  }


  // delete currency
  removeProductSize(id) {
    return this.http.post('api/product/admin/categorySize/remove?id=' + id, this.headerOptions)
  }
  // get all currency
  getListProductSize() {
    return this.http.get('api/product/admin/categorySize/getALl')
  }

}
